/**
 * This component will take care of date range picker
 */
import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import moment, { Moment } from "moment";
import "./style.scss";

interface Props {
  disabledDate?: (date: Moment) => boolean;
  dateFormat: string;
  timeDifference?: any;
  errorMessage?: string;
  defaultDateRange?: any;
  onSubmit: any;
  customClass?: string;
  popupContainerId?: string;
  frequentDefaultDateChange?: boolean;
  allowClear?: boolean
  onCalanderChange?: any;
  open?: boolean
  shouldShowAlert?: boolean
}

const { RangePicker } = DatePicker;

const DateRangePicker = (props: Props) => {
  const {
    dateFormat,
    defaultDateRange = [],
    disabledDate = (date: Moment) => false,
    timeDifference,
    errorMessage = "",
    customClass = "",
    popupContainerId = "",
    frequentDefaultDateChange = false,
    allowClear = false,
    onCalanderChange = () => {},
    open,
    shouldShowAlert = true
  } = props;
  const [dates, setDates] = useState<any>(defaultDateRange);
  // const [dateRangeObj, setDateRangeObj] = useState({ ...selectedDateRange });

  // useEffect(() => {
  //   // let { startDate, endDate } = timeRange([selectedDateRange.from, selectedDateRange.to]);
  //   props.onSubmit({startDate: selectedDateRange.from, endDate: selectedDateRange.to});
  // }, []);

  /**
   * This function will return the startDate and the endDate and it will also check that the selected date ranges should lie in the
   * timeDifference given by the parent component
   * @param data
   */

  useEffect(() => {
    if (frequentDefaultDateChange && defaultDateRange.length) {
      setDates(defaultDateRange);
    }
  }, [defaultDateRange])


  function timeRange(data: any) {
    let endDate = moment(data[1].format()),
      startDate = moment(data[0].format());
    const daysDiff = endDate.diff(startDate, "days"); //it will return the differnce between 2 dates in days unit
    if (daysDiff > timeDifference) {
      errorMessage && alert(errorMessage);
      startDate = moment(moment(endDate).subtract(timeDifference, "d")); //moving the start date to endDate minus the timeDifference
    }
    return { endDate, startDate };
  }

  function onDateRangePickerOk(value: any) {
    if (!value?.length) {
      defaultDateRange?.length && setDates(null);
      defaultDateRange?.length &&
        props.onSubmit({ startDate: null, endDate: null });
      return;
    }
    let { startDate, endDate } = timeRange(value);
    // setDateRangeObj({ from: startDate, to: endDate });
    setDates([startDate, endDate]);
    props.onSubmit({ startDate, endDate });
  }

  return (
    <RangePicker
      getPopupContainer={() => document.getElementById(popupContainerId) || document.body}
      dropdownClassName="abc"
      className={`custom-date-range-picker rounded-[5px] flex w-[232px] sm:w-[100%] border-[#D8D8D8]
        border-[1px] min-h-[36px] text-20 ${customClass || ""}
      `}
      format={dateFormat}
      disabledDate={disabledDate}
      onChange={onDateRangePickerOk}
      onClick={(e) => console.log(e)}
      value={dates}
      allowClear = {allowClear}
      onCalendarChange={onCalanderChange}
      {...(open && {open:true})}
    /> 
  );
};

export default DateRangePicker;
